/**
 * 配送方式数据解析
 * @param transport
 */
const parseTransport = transport => {
  let originTransportList = [1, 2, 4];
  let transportList = [];
  // 配送方式数据解析
  originTransportList.forEach(item => {
    // transport 是配送方式 originTransportList 数组里数字的和
    // 3: 邮寄+自提 5: 邮寄+同城 6: 同城+自提 7: 同城+自提+邮寄
    if ((transport & item) > 0 && transportList.indexOf(item) === -1) {
      transportList.push(item);
    }
  });
  return transportList;
};
export default {
  parseTransport,
};
